export default {
  namespaced: false, //开启命名空间，更好的区分使用stage,防止不同stage模块中的方法重名
  state: {
    schemeInfo: {},
    planTextures: {},
    deviceTextures: {}
  },
  actions: {},
  mutations: {
    setSchemeInfo(state, data) {
      state.schemeInfo = data;
    },
    setPlanTextures(state, data) {
      state.planTextures = data;
    },
    setDeviceTextures(state, data) {
      state.deviceTextures = data;
    }
  },
  getters: {
    schemeInfo: state => state.schemeInfo,
    planTextures: state => state.planTextures,
    deviceTextures: state => state.deviceTextures
  }
};
